import React, { FC } from 'react';
import { Button } from '@components/UIKit/Button/Button';
import { Toy } from '@specs/views';
import { useTranslation } from '@hooks/useTranslation';
import { useRouter } from 'next/router';
import { LinksEnum } from '@specs/navigation';
interface Props {
  slug: Toy.Single['slug'];
}
export const EditToyButton: FC<Props> = ({
  slug
}) => {
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  const editToyHandler = async () => {
    await router.push({
      pathname: LinksEnum.TOY_SELL,
      query: {
        slug
      }
    });
  };
  return <Button id='toy_card_edit_toy_button' color={'White'} size={'medium'} onClick={editToyHandler} icons={{
    left: {
      name: 'edit'
    }
  }} data-sentry-element="Button" data-sentry-component="EditToyButton" data-sentry-source-file="EditToyButton.tsx">
            {tr({
      id: 'btn.edit'
    })}
        </Button>;
};